Raw = require "./raw"

module.exports = class Comment extends Raw
  render: ->
    ""

